import {
  FloatingFormItem,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import BankAccountInfiniteSelectField from '@/components/_common/BankAccountInfiniteSelectField';
import DocumentTypesInfiniteSelectField from '@/components/_common/DocumentTypesInfiniteSelectField';
import {
  InstallmentSettleFormValues,
  SettleInstallmentSingleData,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import formatterPrice from '@/utils/number/formatterPrice';
import { Col, Form, FormInstance, Row, Statistic } from 'antd';
import React from 'react';

interface Props {
  form: FormInstance<InstallmentSettleFormValues>;
  data?: SettleInstallmentSingleData;
}

const SettlePartiallyAccountPayableForm: React.FC<Props> = ({ form, data }) => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const totalValue =
    (data?.installmentValue ?? 0) + (data?.discountIncrease ?? 0) - 0.01;

  const maxValue =
    (data?.installmentValue ?? 0) + (data?.discountIncrease ?? 0);

  return (
    <Form form={form}>
      <Row gutter={24}>
        <Col span={24}>
          <FloatingFormItem
            name={'bankAccountId'}
            label={'Conta bancária'}
            rules={[defaultEmptyFieldError]}
          >
            <BankAccountInfiniteSelectField queryFilter={{ active: true }} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name={'documentTypeId'}
            label={'Tipos de Documento'}
            rules={[defaultEmptyFieldError]}
          >
            <DocumentTypesInfiniteSelectField queryFilter={{ active: true }} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="payDate"
            label="Dt. de Pagamento"
            rules={[defaultEmptyFieldError]}
          >
            <InputDate
              disabled={
                !hasPermissions([
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_EDIT_DATE_SETTLE_INSTALLMENT,
                ])
              }
            />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="dueDate"
            label="Dt. venc. nova parcela"
            rules={[defaultEmptyFieldError]}
          >
            <InputDate />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name="amountToBeSettled"
            label="Valor que será liquidado"
            rules={[
              {
                required: true,
                type: 'number',
                message: 'Digite um valor maior que R$ 0,00',
                min: 0.01,
              },
              {
                type: 'number',
                max: totalValue,
                message: 'Valor deve ser menor que o valor líquido',
              },
            ]}
          >
            <InputDecimal max={maxValue} />
          </FloatingFormItem>
        </Col>

        <Col span={24}>
          <Form.Item noStyle shouldUpdate>
            {({}) => {
              let total = 0;

              if (data) {
                total =
                  (data?.installmentValue ?? 0) +
                  (data.discountIncrease ?? 0) -
                  (data.credit ?? 0);
              }

              return (
                <Statistic
                  title="Total a pagar"
                  value={total}
                  formatter={(value) => formatterPrice(Number(value))}
                  valueStyle={{
                    color: '#148e28',
                  }}
                />
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default SettlePartiallyAccountPayableForm;
